/**
 * Declaration upload state — used on the license-scope page when the
 * user uploads a prior-policy declaration PDF.
 */
class DeclUploadStore {
  #listeners = new Set();

  #declUploading = false;
  #declUploadDone = false;
  #declUploadError = null;
  #declFileName = "";

  get declUploading() { return this.#declUploading; }
  set declUploading(v) { this.#declUploading = !!v; this.#notify(); }

  get declUploadDone() { return this.#declUploadDone; }
  set declUploadDone(v) { this.#declUploadDone = !!v; this.#notify(); }

  get declUploadError() { return this.#declUploadError; }
  set declUploadError(v) { this.#declUploadError = v; this.#notify(); }

  get declFileName() { return this.#declFileName; }
  set declFileName(v) { this.#declFileName = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#declUploading = false;
    this.#declUploadDone = false;
    this.#declUploadError = null;
    this.#declFileName = "";
    this.#notify();
  }
}

const declUploadStore = new DeclUploadStore();
export default declUploadStore;
